import { useTranslation } from 'react-i18next';
import {
  PlainEditor,
  PlainEditorProps,
} from '../../../../components/ui/plain-editor';
import { useUgcDraft } from '../../../../models/ugc-draft/context';
import '../form.scss';

const trackingContext: PlainEditorProps['trackingContext'] = {
  contentSection: 'body',
};

const BodyInput = () => {
  const { ugcDraft, isPersisting, updateUgcDraftFormState } = useUgcDraft();
  const { t } = useTranslation();

  const onTextChange = (body: string) => {
    updateUgcDraftFormState({ body });
  };

  return (
    <PlainEditor
      aria-label={t('ugc_draft.field_body')}
      className="ugc-draft--body"
      defaultValue={ugcDraft.body || ''}
      onChange={onTextChange}
      disabled={isPersisting}
      placeholder={t('ugc_draft.field_body_placeholder')}
      trackingContext={trackingContext}
    />
  );
};

export default BodyInput;
